// AboutPreview.tsx
import React from "react";
import { Link } from "react-router-dom";

function AboutPreview() {
  return (
    <section className="relative overflow-hidden py-20 px-6 bg-gradient-to-br from-indigo-50 via-white to-blue-50">
      {/* Background Accent */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-10 -left-10 w-72 h-72 bg-indigo-100 rounded-full blur-3xl opacity-30"></div>
        <div className="absolute bottom-0 right-0 w-72 h-72 bg-blue-100 rounded-full blur-3xl opacity-40"></div>
      </div>

      <div className="relative max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {/* Left: Image */}
        <div className="order-2 md:order-1 flex justify-center">
          <img
            src="https://stories.freepiklabs.com/storage/16527/466-Team-work_Artboard-1.svg"
            alt="Kevmark Team"
            className="w-full max-w-md md:max-w-lg rounded-2xl shadow-xl hover:scale-[1.02] transition-transform duration-500"
            loading="lazy"
          />
        </div>

        {/* Right: Text + CTA – Elevated Copy */}
        <div className="order-1 md:order-2 text-center md:text-left space-y-6">
          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 leading-tight">
            Trusted Since <span className="text-indigo-600">2008</span>
          </h2>

          <p className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-lg mx-auto md:mx-0">
            <strong>Kevmark Investments Limited</strong> is your{" "}
            <span className="text-indigo-600 font-medium">
              one-stop partner
            </span>{" "}
            for{" "}
            <strong>ICT, stationery, branding, and industrial printing</strong>{" "}
            — delivering <em>fast, reliable, and high-quality</em> solutions to
            schools, SMEs, and government institutions across Uganda.
          </p>

          <div>
            <Link
              to="/about-us"
              className="inline-flex items-center gap-3 bg-indigo-600 text-white px-8 py-3 rounded-xl font-semibold shadow-lg hover:bg-indigo-700 hover:shadow-xl transition-all duration-300 group"
            >
              Discover Our Story
              <svg
                className="w-5 h-5 transform group-hover:translate-x-1 transition-transform"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutPreview;
